import { render, staticRenderFns } from "./OtherPay.vue?vue&type=template&id=d2afb456&scoped=true&"
import script from "./OtherPay.vue?vue&type=script&lang=js&"
export * from "./OtherPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2afb456",
  null
  
)

export default component.exports